import { CameraOutlinedIcon, UploadOutlinedIcon, EditIcon } from '../../../../components/icons'

export const UPLOAD_OPTIONS = [
  {
    icon: <CameraOutlinedIcon sx={{ fontSize: '2rem' }} />,
    title: 'Take a photo',
    description: 'Capture the result with your device',
    action: 'camera',
  },
  {
    icon: <UploadOutlinedIcon sx={{ fontSize: '2rem' }} />,
    title: 'Upload image',
    description: 'Upload image from your gallery',
    action: 'upload',
  },
  {
    icon: <EditIcon sx={{ fontSize: '2rem' }} />,
    title: 'Input data manually',
    description: 'Input the readings manually',
    action: 'manual',
  },
] as const